import { BookingAvailabilitySlot } from '@/types';

/**
 * Builds the list of selectable slot times for a booking DROPDOWN (edit and
 * company-dashboard edit flows). Shared so the two staff/company dropdowns
 * cannot drift the way the overbook feature once did.
 *
 * - When availability has loaded, offer free slots — plus fully-booked slots
 *   too when `allowOverbook` is set (staff overbooking).
 * - When availability has not loaded, fall back to the schedule-generated times.
 * - Always keep the currently-selected time visible even if it is not in the
 *   list (e.g. an existing booking on a now-full slot), so editing never loses
 *   the current value.
 *
 * NOTE: the manual-booking CREATE flow uses a button grid (all slots, gated
 * per-button) and deliberately does NOT use this helper.
 */
export const slotTimesForSelection = ({
  slots,
  hasAvailabilityData,
  generatedTimes = [],
  currentTime,
  allowOverbook = false
}: {
  slots: BookingAvailabilitySlot[];
  hasAvailabilityData: boolean;
  generatedTimes?: string[];
  currentTime?: string | null;
  allowOverbook?: boolean;
}): string[] => {
  const available = hasAvailabilityData
    ? slots.filter((s) => s.available || allowOverbook).map((s) => s.time)
    : generatedTimes;
  if (!currentTime || available.includes(currentTime)) return available;
  return [currentTime, ...available];
};
